import React, { useEffect } from "react";
import Empty from "../../component/empty/Empty";
import WithDockLayout from "../components/with-dock-layout";
import Finder from "./components/finder";

import avatar from '../assets/images/pa.png'

import modStyl from './index.module.scss'
import { Toast } from "antd-mobile";

const JunPatient = ()=> {

  useEffect(()=> {
    window.document.title = "我的患者"
  }, [])

  return (
    <WithDockLayout>
      <>
      <Finder/>
      <div className={modStyl.listWrapper}>
        <ul>
          <li onClick={()=> Toast.show('敬请期待')}>
            <div className={modStyl.wt}>
              <img src={avatar} alt=""/>
            </div>
            <div className={modStyl.md}>
              <div className={modStyl.r1}>
                <span>张三</span>
                <span>男</span>
                <span>患者本人</span>
              </div>
              <div className={modStyl.r2}>
                <span>放疗</span>
                <span>手术前</span>
              </div>
            </div>
          </li>
          <li onClick={()=> Toast.show('敬请期待')}>
            <div className={modStyl.wt}>
              <img src={avatar} alt=""/>
            </div>
            <div className={modStyl.md}>
              <div className={modStyl.r1}>
                <span>张三</span>
                <span>男</span>
                <span>患者本人</span>
              </div>
              <div className={modStyl.r2}>
                <span>放疗</span>
                <span>手术前</span>
              </div>
            </div>
          </li>
          <li onClick={()=> Toast.show('敬请期待')}>
            <div className={modStyl.wt}>
              <img src={avatar} alt=""/>
            </div>
            <div className={modStyl.md}>
              <div className={modStyl.r1}>
                <span>张三</span>
                <span>男</span>
                <span>患者本人</span>
              </div>
              <div className={modStyl.r2}>
                <span>放疗</span>
                <span>手术前</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      {/* <Empty description="暂时无患者记录"/> */}
      </>
    </WithDockLayout>
  )
}

export default JunPatient